import { HomepageBannerItemType } from 'interfaces/types'

export type HomeBannerItem = HomepageBannerItemType

export * from './HomeBanner'
